import CreditCard from "@mui/icons-material/CreditCard";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PhoneIcon from "@mui/icons-material/Phone";
import Print from "@mui/icons-material/Print";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import TableRestaurant from "@mui/icons-material/TableRestaurant";
import { Box, Container, Stack, Tab, Tabs, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import AppSubscriptionsAndBillings from "./AppSubscriptionsAndBillings";
import DineAreas from "../configurations/DineAreasList";
import GeneralSettings from "./GeneralSettings";
import PrinterSettings from "./PrinterSettings";
import "./Settings.css";
import About from "./About";
import ContactInfo from "./ContactInfo";

function Settings(props) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box className="tab-setting">
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  return (
    <>
      <Box className="page-content">
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={1}
          >
            <Typography variant="h5" gutterBottom>
              Settings
            </Typography>
          </Stack>
          <Box className="settings-content">
            <Box sx={{ width: "100%" }}>
              <Box>
                <Tabs
                  variant="scrollable"
                  scrollButtons="auto"
                  indicatorColor="primary"
                  textColor="primary"
                  value={value}
                  onChange={handleChange}
                >
                  {/* <Tab
                    icon={<TableRestaurant size={20} />}
                    className="s-tabs"
                    iconPosition="start"
                    label="Dine Tables"
                    {...a11yProps(0)}
                  /> */}
                  <Tab
                    icon={<SettingsOutlinedIcon size={20} />}
                    className="s-tabs"
                    iconPosition="start"
                    label="General Settings"
                    {...a11yProps(0)}
                  />
                  <Tab
                    icon={<Print size={20} />}
                    className="s-tabs"
                    iconPosition="start"
                    label="Print Settings"
                    {...a11yProps(0)}
                  />
                  <Tab
                    icon={<CreditCard size={20} />}
                    className="s-tabs"
                    iconPosition="start"
                    label="App Subscription & Billing"
                    {...a11yProps(0)}
                  />
                  <Tab
                    icon={<InfoOutlinedIcon size={20} />}
                    className="s-tabs"
                    iconPosition="start"
                    label="About"
                    {...a11yProps(0)}
                  />
                  <Tab
                    icon={<PhoneIcon size={20} />}
                    className="s-tabs"
                    iconPosition="start"
                    label="Contact Info"
                    {...a11yProps(0)}
                  />
                </Tabs>
              </Box>
              {/* <TabPanel value={value} index={0}>
                <DineAreas />
              </TabPanel> */}
              <TabPanel value={value} index={0}>
                <GeneralSettings />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <PrinterSettings />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <AppSubscriptionsAndBillings />
              </TabPanel>
              <TabPanel value={value} index={3}>
                <About />
              </TabPanel>
              <TabPanel value={value} index={4}>
                <ContactInfo />
              </TabPanel>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
}

export default Settings;
